module.exports = __webpack_public_path__ + "static/media/86a7be1e-4deb-4117-9cdc-4ea1402c948f.bb6c743d.jpg";